<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card no-shadow class="pt-1">
          <div slot="no-body" class="mt-4">
            <!-- Button to Create Task Field Page -->
            <div class="flex mb-4 mr-4">
                <vs-button @click="onClickCreateTaskField()" class="mr-4 mb-4" color="primary" type="filled">Add Field</vs-button>
            </div>

            <!-- TaskFields Table -->
            <vs-table :data="taskFields" stripe class="table-dark-inverted table-auto vs-con-loading__container">
                <template slot="thead">
                    <vs-th>Label</vs-th>
                    <!-- <vs-th>Field Type</vs-th>
                    <vs-th width="20%">Description</vs-th>
                    <vs-th>Required</vs-th> -->
                    <vs-th class="text-xs">ACTION</vs-th>
                </template>

                <template slot-scope="{ data }">
                    <vs-tr v-for="taskField in data" :key="taskField.id">
                        <vs-td>{{ taskField.label }}</vs-td>
                        <!-- <vs-td>{{ taskField.type }}</vs-td>
                        <vs-td>{{ taskField.description }}</vs-td>
                        <vs-td>{{ taskField.is_required }}</vs-td> -->
                        <vs-td>
                            <div class="vx-row">
                                <vx-tooltip text="Edit Task Field" position="top">
                                    <vs-button class="mr-2"
                                            @click.stop="onClickViewTaskField(taskField)"
                                            size="small" color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                                </vx-tooltip>
                                <vx-tooltip text="Delete Task Field" position="top">
                                    <vs-button class="mr-2"
                                            @click.stop="onClickDeleteTaskField(taskField.id)"
                                            size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash"></vs-button>
                                </vx-tooltip>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
         <CreateTaskField ref="createTaskField" />
    </div>
  </div>

</template>

<script>
import ScheduledTasksRepository from "@/repository/ScheduledTasksRepository";
import CreateTaskField from "../../../../../components/popups/settings/scheduled-tasks/CreateTaskField.vue";

export default {
  name: "TaskFields",
  data() {
    return {
      taskFields: [],
    };
  },
  components: {
    CreateTaskField
  },
  methods: {
    async fetchTaskFields() {
      try {
        const response = await ScheduledTasksRepository.getTemplateDetails(this.id);
        this.taskFields = response.data.data.fields || response.data;
      } catch (error) {
        console.error("Error fetching taskFields:", error);
      }
    },
    onClickViewTaskField(taskField) {
      this.$refs.createTaskField.openPopup(
        taskField,
        this.id
      );
    },
    onClickCreateTaskField(){
      this.$refs.createTaskField.openPopup(
        null,
        this.id,
      );
    },
    async onClickDeleteTaskField(id){
      try {
        const response = await ScheduledTasksRepository.deleteTaskField(id);
        this.refreshData();
      } catch (error) {
        console.error("Error deleting taskFields:", error);
      }
    },
    refreshData(){
      this.fetchTaskFields();
    }
  },
  mounted() {
    this.id = this.$route.params.id
      this.fetchTaskFields();
  },
 
};
</script>

